import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaFileAlt, FaFolderOpen } from 'react-icons/fa';
import TermsAndConditions from './terms/TermsAndConditions';
import CategoriesTable from '../Category/CategoriesTable';

const Settings = () => {
  const [showTerms, setShowTerms] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const location = useLocation();

  // Reinicia el estado al entrar a /settings
  useEffect(() => {
    setShowTerms(false);
    setShowCategories(false);
  }, [location.pathname]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Configuraciones</h1>

      {showTerms ? (
        <TermsAndConditions />
      ) : showCategories ? (
        <CategoriesTable />
      ) : (
        <div className="mx-4 md:mx-8 lg:mx-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div
              className="p-4 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-50 hover:border-indigo-500 transition-all duration-300 cursor-pointer"
              onClick={() => setShowTerms(true)}
            >
              <FaFileAlt className="text-indigo-500 mb-2" size={24} />
              <h3 className="text-lg font-semibold mb-2">Términos y Condiciones</h3>
              <p className="text-sm text-gray-600">
                Administre los términos legales que los clientes deben aceptar al crear una cuenta y realizar pedidos.
              </p>
            </div>

            <div
              className="p-4 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-50 hover:border-indigo-500 transition-all duration-300 cursor-pointer"
              onClick={() => setShowCategories(true)}
            >
              <FaFolderOpen className="text-blue-600 mb-2" size={24} />
              <h3 className="text-lg font-semibold mb-2">Categorías</h3>
              <p className="text-sm text-gray-600">
                Administre las categorías disponibles para organizar los recursos o productos descargables.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Settings;
